import { supabase } from "@/lib/supabase"

export async function isCurrentUserAdmin(): Promise<boolean> {
  try {
    const { data: auth } = await supabase.auth.getUser()
    const uid = auth.user?.id
    if (!uid) return false
    return false
  } catch {
    return false
  }
}
